import store from '../../store/index';
import router from '../../routes';
import EventObject from '../../../modules/tracking/EventObject';

export default function(label = 'Create stock alert clicked') {
    if (store.state.UsedSearchOptions.options.count >= 100) {
        new EventObject('Stock Alert', 'Directed to landing page - too many vehicles', label).dispatch();
        router.push({name:'car-alert'}).catch(error => {
            console.error(error);
        });
        return;
    }
    if (store.state.UsedSearchOptions.userOptions.manufacturer == '') {
        new EventObject('Stock Alert', 'Directed to landing page - no manufacturer', label).dispatch();
        router.push({name:'car-alert'}).catch(error => {
            console.error(error);
        });
        return;
    }
    if (store.state.UsedSearchOptions.userOptions.model == '') {
        new EventObject('Stock Alert', 'Directed to landing page - no model', label).dispatch();
        router.push({name:'car-alert'}).catch(error => {
            console.error(error);
        });
        return;
    }else{
        router.push({name:'car-alert'}).catch(error => {
            console.error(error);
        });
    }

    new EventObject('Stock Alert', 'Directed to landing page', label).dispatch();
    router.push({name:'car-alert'}).catch(error => {
        console.error(error);
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/used-vue/api/car-alert/CreateCarAlert.js